module.exports = __webpack_public_path__ + "img/map.136b06eb.png";